import { Box, Paper } from "@mui/material";
import { RESEARCH_LINKS } from "../../config/SideNav";
import ResearchTile from "../generic/ResearchTile";

const SchoolSimsResearchTile = () => (
  <Paper className="edsimsV2-cohort-dashboard-card" elevation={0}>
    <Box className="edsimsV2-cohort-dashboard-header">
      <Box component="h2" className="edsimsV2-tile-title">
        SchoolSims research
      </Box>
      <p className="edsimsV2-tile-body">
        Peer-reviewed research, recorded webinars, and client white papers
        supporting simulation-based learning.
      </p>
    </Box>
    <Box
      className="edsimsV2-research-tiles"
      component="nav"
      aria-label="SchoolSims research resources"
    >
      <ResearchTile
        label="Research"
        href={RESEARCH_LINKS.research}
        iconClass="fas fa-book-open"
        bg="#EEEDFE"
        color="#534AB7"
      />
      <ResearchTile
        label="Webinars"
        href={RESEARCH_LINKS.webinars}
        iconClass="fas fa-desktop"
        bg="#E1F5EE"
        color="#3E796C"
      />
      <ResearchTile
        label="White Papers"
        href={RESEARCH_LINKS.whitePapers}
        iconClass="fas fa-file-alt"
        bg="#F7E7FF"
        color="#C56CB6"
      />
    </Box>
  </Paper>
);

export default SchoolSimsResearchTile;
